import type { GetterTree } from "vuex";
import type { RootState, WebSocketState } from "@/types";

export const getters: GetterTree<WebSocketState, RootState> = {
  getWebsocketMessage(state) {
    return state.wsData;
  },
  getWebsocket(state) {
    return state.ws;
  },
  getManualData(state) {
    return state.uploadManualData;
  },
  getValidateUploadlData(state) {
    return state.wsValidateData;
  },
};
